import React, { useEffect } from 'react';
import {
  Button,
  Card,
  Link,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import moment from 'moment';

import { useFormatMessage } from '../../../../../hooks';
import { useStyles } from './hooks/useStyles';
import { SHeadTableCell } from '../../../../../components/styledComponents/Tables';
import Preloader from '../../../../../components/other/Preloader/Preloader';
import TablePaginator from '../../../../../components/TablePaginator/TablePaginator';
import { useGetImportFiles } from './hooks/useGetImportFiles';
import { API_DOMAIN } from '../../../../../constants';
import { useDeleteImport } from './hooks/useDeleteImport';
import { ModalErrors } from './ModalErrors';

export function ErrorsFiles() {
  const fm = useFormatMessage();
  const { classes } = useStyles();
  const { fetchImportOffers, loadingOffers, offers, page } = useGetImportFiles();
  const { fetchDelete, loadingDelete, successDelete } = useDeleteImport();
  const [id, setId] = React.useState<number | null>(null);

  useEffect(() => {
    fetchImportOffers({ page: 1, per_page: 20, errors: true });
  }, []);

  useEffect(() => {
    if (successDelete) fetchImportOffers({ page: 1, per_page: 20, errors: true });
  }, [successDelete]);

  return (
    <Card className={classes.card}>
      {loadingOffers || !offers ? (
        <Preloader />
      ) : (
        <>
          {offers.length > 0 ? (
            <>
              <Table aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <SHeadTableCell className={classes.rowItems}>Дата импорта</SHeadTableCell>
                    <SHeadTableCell className={classes.rowItems}>Компания</SHeadTableCell>
                    <SHeadTableCell className={classes.rowItems}>Файл импорта</SHeadTableCell>
                    <SHeadTableCell className={classes.rowItems}>Удалено</SHeadTableCell>
                    <SHeadTableCell className={classes.rowItems}>
                      Ошибки в файле
                    </SHeadTableCell>
                    <SHeadTableCell className={classes.rowItems} />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {offers?.map(offer => (
                    <TableRow key={offer.id}>
                      <TableCell component='th' scope='row' className={classes.rowItems}>
                        {moment(offer.created_at).format('DD.MM.YYYY HH:mm')}
                      </TableCell>
                      <TableCell component='th' scope='row' className={classes.rowItems}>
                        {offer.company ? (
                          <Link
                            component={RouterLink}
                            to={`/companies/edit/${offer.company.id}`}
                          >
                            {offer.company?.brand || offer.company?.name}
                          </Link>
                        ) : (
                          '-'
                        )}
                      </TableCell>
                      <TableCell component='th' scope='row' className={classes.rowItems}>
                        {offer.path ? (
                          <Button
                            onClick={() => window.open(`${API_DOMAIN}${offer.path}`, '_blank')}
                            variant='contained'
                          >
                            Файл
                          </Button>
                        ) : (
                          '-'
                        )}
                      </TableCell>
                      <TableCell>{offer.deleted_num || '-'}</TableCell>
                      <TableCell component='th' scope='row' className={classes.rowItems}>
                        {offer.errors_path && offer.errors_num > 0 && (
                          <>
                            <Button
                              onClick={() =>
                                window.open(`${API_DOMAIN}${offer.errors_xlsx_path || offer.errors_path}`, '_blank')
                              }
                              variant='contained'
                            >
                              Файл
                            </Button>
                            <Button className={classes.btnTwo} variant='contained' onClick={()=> setId(offer.id)}>
                              Просмотр
                            </Button>
                          </>
                        )}
                      </TableCell>
                      <TableCell component='th' scope='row' className={classes.rowItems}>
                        <Button
                          onClick={() => fetchDelete(offer.id)}
                          variant='contained'
                          disabled={loadingDelete}
                        >
                          Удалить файл
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <div className={classes.containerPagination}>
                <TablePaginator
                  page={page.page}
                  realPerPage={offers?.length}
                  perPage={page.perPage}
                  total={page.total}
                  fetchRows={(data: any) =>
                    fetchImportOffers({
                      page: data.page,
                      per_page: data.perPage,
                      errors: true
                    })
                  }
                />
              </div>

              <ModalErrors id={id} closeModal={() => setId(null)} />
            </>
          ) : null}
        </>
      )}
    </Card>
  );
}
